const initAdPricing = ( root ) => {
	const steps = Array.from(
		root.querySelectorAll( '[data-placement-step]' )
	);

	if ( ! steps.length ) {
		return;
	}

	const toast = root.querySelector( '[data-placement-toast]' );

	if ( ! toast ) {
		return;
	}

	const previews = Array.from(
		root.querySelectorAll( '[data-placement-preview]' )
	);
	const stepsRegion = root.querySelector( '[data-placement-steps]' ) || root;
	const toastContent = root.querySelector( '[data-placement-toast-content]' );
	const toastName = root.querySelector( '[data-placement-toast-name]' );
	const toastPrice = root.querySelector( '[data-placement-toast-price]' );
	const toastLink = root.querySelector( '[data-placement-toast-link]' );
	const toastChannel = root.querySelector( '[data-placement-toast-channel]' );
	const progress = root.querySelector( '[data-placement-progress-current]' );
	const reducedMotion = window.matchMedia(
		'(prefers-reduced-motion: reduce)'
	).matches;
	let activeIndex = 0;
	let hasActivated = false;
	let sectionVisible = false;
	let toastTimer;

	const setToastVisible = ( visible ) => {
		toast.dataset.visible = visible ? 'true' : 'false';
	};

	const updateToast = ( step ) => {
		const applyContent = () => {
			toastChannel.textContent = step.dataset.placementChannel;
			toastName.textContent = step.dataset.placementName;
			toastPrice.textContent = step.dataset.placementPrice;
			toastLink.href = `mailto:ewander@acec.org?subject=${ encodeURIComponent(
				`Advertising inquiry: ${ step.dataset.placementName }`
			) }`;
			toastContent.style.opacity = '1';
		};

		window.clearTimeout( toastTimer );

		if ( hasActivated && ! reducedMotion ) {
			toastContent.style.opacity = '0';
			toastTimer = window.setTimeout( applyContent, 140 );
		} else {
			applyContent();
		}
	};

	const activate = ( index ) => {
		if ( index === activeIndex && hasActivated ) {
			return;
		}

		const previousIndex = activeIndex;
		activeIndex = index;

		steps.forEach( ( step, stepIndex ) => {
			step.dataset.active = stepIndex === index ? 'true' : 'false';
			step.setAttribute(
				'aria-current',
				stepIndex === index ? 'step' : 'false'
			);
		} );

		previews.forEach( ( preview, previewIndex ) => {
			const isActive = previewIndex === index;
			const isBefore = previewIndex < index;
			const offset = isBefore ? '-12px' : '24px';
			const scale = isBefore ? '.99' : '.985';

			preview.style.opacity = isActive ? '1' : '0';
			preview.style.transform = isActive
				? 'translateY(0) scale(1)'
				: `translateY(${ offset }) scale(${ scale })`;
			preview.setAttribute( 'aria-hidden', isActive ? 'false' : 'true' );
		} );

		const step = steps[ index ];
		progress.textContent = String( index + 1 ).padStart( 2, '0' );
		updateToast( step );

		if ( sectionVisible ) {
			setToastVisible( true );
		}

		hasActivated = true;

		if ( previousIndex !== index ) {
			root.dispatchEvent(
				new CustomEvent( 'enginc:ad-placement-change', {
					detail: { index, name: step.dataset.placementName },
				} )
			);
		}
	};

	const chooseCenteredStep = () => {
		const center = window.innerHeight / 2;
		let closestIndex = activeIndex;
		let closestDistance = Number.POSITIVE_INFINITY;

		steps.forEach( ( step, index ) => {
			const rect = step.getBoundingClientRect();
			const distance = Math.abs( rect.top + rect.height / 2 - center );

			if ( distance < closestDistance ) {
				closestDistance = distance;
				closestIndex = index;
			}
		} );

		activate( closestIndex );
	};

	const stepObserver = new IntersectionObserver( chooseCenteredStep, {
		rootMargin: '-45% 0px -45% 0px',
		threshold: 0,
	} );

	steps.forEach( ( step ) => stepObserver.observe( step ) );

	const sectionObserver = new IntersectionObserver(
		( [ entry ] ) => {
			sectionVisible = entry.isIntersecting;

			if ( sectionVisible ) {
				chooseCenteredStep();
				setToastVisible( true );
			} else {
				setToastVisible( false );
			}
		},
		{ threshold: 0 }
	);

	sectionObserver.observe( stepsRegion );
	root.dataset.enhanced = 'true';
};

document
	.querySelectorAll( '[data-placement-pricing]' )
	.forEach( ( root ) => initAdPricing( root ) );
